import axios from 'axios';
import {REQUEST_URL} from '../config/urls';

const requisitar = () => {
  return {
    type: "REQUISITAR_USUARIO_CONTRATO"
  };
}

const erro = (erro) => {
  if (erro.response.data.error.statusCode === 401) {
    axios.defaults.headers.common['Authorization'] = "";
    return {
      type: "LOGOUT"
    }
  }
  return {
    type: "ERRO_USUARIO",
    erro
  }
}

const obterTodosPeloContrato = (usuarioContrato) => {
  return {
    type: "OBTER_TODOS_USUARIOS_PELO_CONTRATO",
    usuarioContrato
  }
}

const novoUsuarioContrato = (usuarioContrato) => {
  return {
    type: "NOVO_USUARIO_CONTRATO",
    usuarioContrato
  }
}

// FUNÇÕES EXPORTADAS

export const adicionarUsuarioContrato = (usuarioContrato) => {
  return dispatch => {
    dispatch(requisitar());
    return axios.post(`${REQUEST_URL}/usuariosContratos`, usuarioContrato).then((response) => {
      dispatch(novoUsuarioContrato(response.data));
    }).catch(error => {
      dispatch(erro(error.response.data.error));
    });
  }
}

export const obterUsuariosPeloContrato = (id) => {
  return dispatch => {
    dispatch(requisitar());
    return axios.get(`${REQUEST_URL}/usuariosContratos?filter={"where":{"contrato":"${id}"}}`).then((response) => {
      dispatch(obterTodosPeloContrato(response.data));
    }).catch(error => {
      dispatch(erro(error.response.data.error));
    });
  }
}


// WEBPACK FOOTER //
// ./src/actions/UsuarioContratoActions.js